import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useTutorial } from '../contexts/TutorialContext';
import { getTranslation } from '../languages';

const TutorialButton = ({ uiLanguage = 'en' }) => {
    const { startTutorial, showTutorialButton } = useTutorial();
    
    const t = (key) => getTranslation(key, uiLanguage);
    
    if (!showTutorialButton) return null;
    
    return (
        <button 
            onClick={() => startTutorial('onboarding')}
            className="flex items-center gap-1 px-3 py-1 text-sm text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-md transition-colors"
            title={t('startTutorial') || 'Start Tutorial'}
            data-tutorial-target="tutorial-button"
        >
            <HelpCircle size={16} />
            {t('tutorial') || 'Tutorial'}
        </button>
    );
};

export default TutorialButton;